import React from 'react'
import styled from '@emotion/styled/macro'
import { keyframes } from '@emotion/react'
const bounce = keyframes`
  from, 20%, 53%, 80%, to {
    transform: translate3d(0,0,0);
  }

  40%, 43% {
    transform: translate3d(0, -30px, 0);
  }

  70% {
    transform: translate3d(0, -15px, 0);
  }

  90% {
    transform: translate3d(0,-4px,0);
  }
`
const Loading = styled('div')`
    width: 2rem;
    height: 2rem;
    justify-content: center;
    text-align: center;
    background: var(--colors-primary-main);
    border: var(--borders-main);
    border-radius: 50%;
    animation: ${bounce} 1s ease infinite;
`

export default Loading
